export default "__VITE_ASSET__b2e477d9__"